// const dev_url = 'http://192.168.0.226:8080/api/v1';

// const dev_url = 'http://uplift-api-dev.us-east-1.elasticbeanstalk.com/api/v1';

const dev_url = 'http://localhost:8081/api/v1';
// const dev_url = 'http://ec2-3-138-126-132.us-east-2.compute.amazonaws.com/api/v1';
// const dev_url = 'http://clone-new-uplift-env.eba-d8p95xpk.us-east-1.elasticbeanstalk.com/api/v1';
// const dev_url = 'http://test-elevator-env.eba-pud4tp9m.us-east-1.elasticbeanstalk.com/api/v1';

// const prod_url =
//   'https://app-api.uplift-ks.com/api/v1';

// --------------------new deployment added---------------

const prod_url =
'https://new-api.uplift-ks.com/api/v1';

// Production builds (Amplify runs `yarn build`, NODE_ENV=production) must hit the prod API;
// `yarn start` keeps using dev_url. Never hardcode dev_url here again — it took prod down.
export const BASE_URL =
  process.env.NODE_ENV === 'production' ? prod_url : dev_url;
// export const BASE_URL =
//   !process.env.NODE_ENV || process.env.NODE_ENV === 'development'
//     ? dev_url
//     : prod_url;
